import Image from "next/image"
import useGlobalStore from "stores/global"
import { AppInterface } from "types/types"
import imagePlaceholder from "utils/imagePlaceholder"
import AppActionArea from "./AppActionArea"
import DetailsArea from "./DetailsArea"

interface Props {
  app?: AppInterface
}

const MobileMainAppCard = ({ app }: Props) => {
  const isDark = useGlobalStore((state) => state.isDark)
  const hasScreenshot = app?.screenshotUrls?.[0]

  return (
    <div className="main-app-card">
      <div
        style={{ height: 350, position: "absolute", inset: 0, zIndex: 0 }}
        className="parallax"
      >
        {hasScreenshot ? (
          <Image
            src={hasScreenshot}
            fill
            alt="app screenshot"
            style={{ objectFit: "cover" }}
            placeholder="blur"
            blurDataURL={imagePlaceholder(isDark)}
            priority
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Image
              src={app?.artworkUrl512 || imagePlaceholder(isDark)}
              fill
              alt="app icon background"
              style={{
                objectFit: "cover",
                filter: "blur(40px) brightness(0.8)",
                transform: "scale(1.2)",
                animation: "slowRotate 60s linear infinite",
              }}
              placeholder="blur"
              blurDataURL={imagePlaceholder(isDark)}
              priority
            />
          </div>
        )}
        <div className="card-overlay app-bg-gradient-fade rounded-0"></div>
      </div>
      <div className="mx-3">
        <div
          className="position-relative mb-3"
          style={{
            height: "320px",
          }}
        >
          <AppActionArea app={app} isMobile={true} />
        </div>
        <div className="card card-style m-0 mb-4">
          <div className="card mb-0">
            <DetailsArea app={app} isMobile={true} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileMainAppCard
